import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BoqApp from './boq/App';
import reportWebVitals from './reportWebVitals';

// REACT_APP_TARGET is substituted at build time by CRA. Default
// build → timetracker; `REACT_APP_TARGET=boq npm run build` → BOQ app.
// Two Vercel projects build from this same repo with different env values.
const RootApp = process.env.REACT_APP_TARGET === 'boq' ? BoqApp : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
